import { render } from "./Multisend.vue?vue&type=template&id=14867355"
import script from "./Multisend.vue?vue&type=script&lang=js"
export * from "./Multisend.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__